import '@fontsource/instrument-sans/400.css';
import '@fontsource/instrument-sans/500.css';
import '@fontsource/instrument-sans/600.css';
import '@fontsource/instrument-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

const rot = document.getElementById('rot');
if (!rot) throw new Error('Elementet #rot saknas i index.html');
createRoot(rot).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
